import privacyList from '../../data/haPrivacyList.json'
import { Container } from 'react-bootstrap'

const renderContent = (text) => {
  const parts = text.split(/(<(?:https?:\/\/|[^\s@>]+@)[^>]+>)/g)
  return parts.map((part, i) => {
    const urlMatch = part.match(/^<(https?:\/\/[^>]+)>$/)
    const emailMatch = part.match(/^<([^\s@>]+@[^>]+)>$/)
    if (urlMatch) {
      return (
        <a
          key={i}
          href={urlMatch[1]}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#28d9c4', cursor: 'pointer' }}
        >
          {urlMatch[1]}
        </a>
      )
    }
    if (emailMatch) {
      return (
        <a
          key={i}
          href={`mailto:${emailMatch[1].trim()}`}
          style={{ color: '#28d9c4', cursor: 'pointer' }}
        >
          {emailMatch[1].trim()}
        </a>
      )
    }
    return part
  })
}

const HaPrivacy = () => {
  return (
    <>
      {' '}
      <Container
        style={{
          padding: '1rem',
          textAlign: 'justify',
          fontFamily: 'Noto Sans TC,sans-serif',
        }}
      >
        <div style={{ padding: '1rem', lineHeight: '1.5' }}>
          <h4 style={{ color: '#28d9c4' }}>隱私權保護聲明</h4>
          <p>最後更新⽇期：2026 年 03 ⽉ 31 ⽇</p>
          <p>
            浚鴻數據開發股份有限公司（下稱「本公司」），尊重並承諾保護使用者隱私，在您使⽤本公司所提供的HA！健康APP服務（以下稱「本應用程式」）前，特向您說明本應用程式之隱私權政策（下稱「本聲明」），請您詳閱下列內容，以保障您的權益：
          </p>
        </div>
        {privacyList.map((item, index) => {
          return (
            <div key={index} style={{ padding: '1rem' }}>
              <h4>{item.title}</h4>
              <p style={{ whiteSpace: 'pre-wrap', lineHeight: '1.5' }}>
                {renderContent(item.content)}
              </p>
            </div>
          )
        })}
      </Container>
    </>
  )
}

export default HaPrivacy
